<div class="oc-menu">
  @for (menu of data(); track menu.item) {
    @if (!menu.isHidden) {
      <button
        class="oc-menu__button"
        (click)="menuChangeEmit.emit(menu)"
        [class.is-tablet]="!isVisible()"
        [routerLink]="menu.routerLink"
        [routerLinkActive]="'is-active'"
        [routerLinkActiveOptions]="{exact: false}">
        <mat-icon
          class="oc-menu__button-icon"
          [matBadge]="menu?.badgeCount || 0"
          aria-hidden="false"
          [matBadgeHidden]="!menu?.badgeCount"
          [ngClass]="menu.iconClass"
          >{{ menu.icon }}</mat-icon
        >
        @if (isVisible()) {
          {{ menu.item }}
        }
      </button>
    }
  }
</div>
